var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogleDrive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 29 24",
    width: 29,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.153 6.392l2.504-2.503.167-1.054C17.262-1.314 10.01-.843 5.897 3.816 4.755 5.11 3.907 6.723 3.456 8.389l.896-.126 5.007-.826.387-.395c2.227-2.446 5.992-2.775 8.564-.694z",
    fill: "#ea4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.223 8.316a11.278 11.278 0 00-3.4-5.482L18.31 6.348a6.245 6.245 0 012.293 4.954v.624c1.727 0 3.127 1.4 3.127 3.127 0 1.727-1.4 3.092-3.127 3.092H14.34l-.615.668v3.75l.615.589h6.263c4.492.035 8.162-3.543 8.197-8.035a8.134 8.134 0 00-3.577-6.801z",
    fill: "#4285f4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.085 23.152h6.255v-5.007H8.085a3.07 3.07 0 01-1.282-.28l-.887.272-2.521 2.503-.22.852c1.414 1.068 3.139 1.668 4.91 1.66z",
    fill: "#34a853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.085 6.91a8.134 8.134 0 00-4.91 14.582l3.628-3.628a3.127 3.127 0 114.137-4.137l3.628-3.628a8.125 8.125 0 00-6.483-3.188z",
    fill: "#fbbc05"
  })));
}

export default SvgGoogleDrive;